import React from 'react';

const About = () => (
    <div style={{margin:'10px',padding:'10px'}}>
        <h1>About Us</h1>
        <p style={{fontSize:"20px"}}>
        Dhaka Foodies Hub is an online gift delivery service that lets you order online from their favorite local restaurants and grocery stores. You can also recharge your mobile online.
       </p>
    </div>
)
export default About;